module.exports = __webpack_public_path__ + "img/la-made.632448fb.svg";